/* BeBobi — modyfikacje na PDP (indywidualny wymiar szelek / wydłużenie smyczy).
   Usługa (MOD_17 / MOD_24) wjeżdża do koszyka jako KOMPONENT reconcilera
   (bebobi-cart-bundles.js): properties {_bbGroup, _bbRole:'component',
   _bbSlot:'mod', _bbKind:'mod', _bbPer:<metry>}, quantity = metry × ilość
   produktu głównego. Dzięki temu planOps() utrzymuje ilość usługi przy każdej
   zmianie ilości smyczy (drawer, /cart, inna karta), a sierocy sweep usuwa ją,
   gdy smycz wyleci z koszyka — mnożenie 7,99 zł/m naprawione u źródła.
   Wymiary psa nadal lecą jako properties pozycji głównej (ukryte inputy).

   Mechanika dodania: nasłuch cart:update (CartAddEvent z product-form-component)
   filtrowany po productId tego PDP — bez monkey-patcha window.fetch (stary hook
   łapał KAŻDY /cart/add, także quick-add innych produktów). Odświeżenie drawera
   robi reconciler własnym CartUpdateEvent po weryfikacji koszyka. */

const CART_UPDATE = 'cart:update';

const groupId = () => `bb_${Math.random().toString(36).slice(2, 10)}`;

class BebobiMods extends HTMLElement {
  connectedCallback() {
    this.mode = this.dataset.mode;
    this.serviceVariant = Number(this.dataset.serviceVariant);
    this.qty = 0;
    this.group = groupId();
    this.toggle = this.querySelector('[data-mod-toggle]');
    this.details = this.querySelector('[data-mod-details]');
    this.note = this.querySelector('[data-mod-note]');
    this.qtyEl = this.querySelector('[data-mod-qty]');
    this.baseLength = Number(this.dataset.baseLength) || 0;
    this.totalWrap = this.querySelector('[data-mod-total]');
    this.totalVal = this.querySelector('[data-mod-total-val]');

    /* formularz i productId TEGO produktu — nie pierwszy formularz w dokumencie
       (na PDP są też formy quick-add rekomendacji) */
    const pfc =
      this.closest('.shopify-section')?.querySelector('product-form-component') ||
      document.querySelector('product-form-component');
    this.productId = pfc?.dataset.productId || '';
    this.form = pfc?.querySelector('form[data-type="add-to-cart-form"]') || null;

    this.toggle?.addEventListener('change', () => {
      if (this.details) this.details.hidden = !this.toggle.checked;
      this.syncProps();
    });
    this.note?.addEventListener('input', () => this.syncProps());
    this.querySelector('[data-mod-plus]')?.addEventListener('click', () => this.setQty(this.qty + 1));
    this.querySelector('[data-mod-minus]')?.addEventListener('click', () => this.setQty(this.qty - 1));

    this.onCartUpdate = (event) => this.handleCartUpdate(event);
    document.addEventListener(CART_UPDATE, this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(CART_UPDATE, this.onCartUpdate);
  }

  setQty(n) {
    this.qty = Math.max(0, Math.min(5, n)); // limit 5 m na jedną smycz
    if (this.qtyEl) this.qtyEl.textContent = this.qty;
    this.updateTotal();
    this.syncProps();
  }

  /* „Długość smyczy: 1,5 m → po wydłużeniu: 3,5 m" */
  updateTotal() {
    if (!this.totalWrap || !this.baseLength) return;
    if (this.qty > 0) {
      const total = this.baseLength + this.qty;
      const en = (document.documentElement.lang || 'pl').toLowerCase().startsWith('en');
      const disp = String(Math.round(total * 10) / 10).replace(/\.0$/, '');
      if (this.totalVal) this.totalVal.textContent = `${en ? disp : disp.replace('.', ',')} m`;
      this.totalWrap.hidden = false;
    } else {
      this.totalWrap.hidden = true;
    }
  }

  isOn() {
    return this.mode === 'wymiar' ? !!this.toggle?.checked : this.qty > 0;
  }

  /* metry usługi na JEDNĄ sztukę produktu głównego (_bbPer) */
  perUnit() {
    return this.mode === 'wymiar' ? 1 : this.qty;
  }

  /* ukryte inputy properties w formularzu głównego produktu */
  syncProps() {
    const form = this.form;
    if (!form) return;
    form.querySelectorAll('[data-bb-mod-prop]').forEach((el) => el.remove());
    if (!this.isOn()) return;
    const add = (name, value) => {
      const i = document.createElement('input');
      i.type = 'hidden';
      i.name = `properties[${name}]`;
      i.value = value;
      i.setAttribute('data-bb-mod-prop', '');
      form.appendChild(i);
    };
    /* rodzic grupy reconcilera — usługa doklei się jako component tej grupy */
    add('_bbGroup', this.group);
    add('_bbRole', 'parent');
    if (this.mode === 'wymiar') {
      add('Indywidualny wymiar', 'tak (+usługa w koszyku)');
      if (this.note?.value.trim()) add('Wymiary psa', this.note.value.trim().slice(0, 250));
    } else {
      let label = `+${this.qty} m`;
      if (this.baseLength) {
        const disp = String(Math.round((this.baseLength + this.qty) * 10) / 10).replace('.', ',');
        label += ` → razem ${disp} m`;
      }
      add('Wydłużenie smyczy', `${label} (usługa w koszyku)`);
    }
  }

  async handleCartUpdate(event) {
    const data = event?.detail?.data;
    if (!data || data.source !== 'product-form-component') return;
    if (String(data.productId || '') !== String(this.productId)) return;
    if (!this.isOn() || !this.serviceVariant) return;

    const group = this.group;
    const per = this.perUnit();
    const parentQty = Math.max(1, Number(data.itemCount) || 1);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: this.serviceVariant,
              quantity: per * parentQty,
              properties: {
                _bbGroup: group,
                _bbRole: 'component',
                _bbSlot: 'mod',
                _bbKind: 'mod',
                _bbPer: String(per),
              },
            },
          ],
        }),
      });
      if (!res.ok) return;
      /* świeża grupa DOPIERO po udanym dodaniu pary smycz+usługa — regeneracja
         przy submit robiła wyścig: formularz serializował się ze starym nonce,
         a usługa dostawała nowy (grupy się rozjeżdżały, usługa sierotą) */
      this.group = groupId();
      this.syncProps();
      /* zbudź reconciler (źródło ≠ bebobi-cart-bundles) — zweryfikuje ilości
         i sam odświeży drawer swoim CartUpdateEvent */
      document.dispatchEvent(
        new CustomEvent(CART_UPDATE, {
          bubbles: true,
          detail: { resource: null, sourceId: 'bebobi-mods', data: { source: 'bebobi-mods' } },
        })
      );
    } catch (e) {
      /* nie blokuj głównego flow */
    }
  }
}
customElements.define('bebobi-mods', BebobiMods);
